<template>
  <div class="w-full">
    <canvas ref="chartDonutRef" height="280"/>
    <div class="flex justify-between mt-3  mb-3 gap-[3px] flex-wrap">
      <div>
        <div class="custom-legend" @click="toggleData(0)">
          <div class="labels-color" id="firstLabelsBG"></div>
          <div>
            <div>
              <span class="text-[12px] text-gray-600" id="firstLabels"></span>
            </div>
            <div>
              <span>{{getPercent(0)}}%</span>
               <span class="text-gray-600 text-[12px]"><span class="px-1">/</span><span id="firstLabelsAmount"></span></span>
            </div>
          </div>
        </div>
      </div>
      <div>
        <div class="custom-legend" @click="toggleData(1)">
          <div class="labels-color" id="secondLabelsBG"></div>
          <div>
            <div>
              <span class="text-[12px] text-gray-600" id="secondLabels"></span>
            </div>
            <div>
              <span>{{getPercent(1)}}%</span>
               <span class="text-gray-600 text-[12px]"><span class="px-1">/</span><span id="secondLabelsAmount"></span></span>
            </div>
          </div>
        </div>
      </div>
      <div>
        <div class="custom-legend" @click="toggleData(2)">
          <div class="labels-color" id="thirdLabelsBG"></div>
          <div>
            <div>
              <span class="text-[12px] text-gray-600" id="thirdLabels"></span>
            </div>
            <div>
              <span>{{getPercent(2)}}%</span>
              <span class="text-gray-600 text-[12px]"><span class="px-1">/</span><span id="thirdLabelsAmount"></span></span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import Chart from 'chart.js'
import { onMounted, ref, watch, computed } from 'vue'
import {millionShortNum,millionShortString,globalNumDecFixed} from "@/utils/format-number"

const props = defineProps({
  chartLabel:{
    type: Array,
    default: ()=>[]
  },
  seriesData:{
    type: Array,
    default: ()=> []
  },
  totalData:{
    type: Number,
    default: 0
  },

})
const data = computed(()=>{
  return{
    labels: props.chartLabel,
    datasets: [
      {
        data: props.seriesData,
        backgroundColor: ["#A9BB5C", "#fe905f", "#f4c92e"],
        hoverBackgroundColor: ["#A9BB5C", "#fe905f", "#f4c92e"],
        borderWidth: 3,
        // borderColor: darkMode.value ? "#303953" : "#fff",
      },
    ],
  }
})

const stackedText = {
  id: "stackedtext",
  afterDatasetsDraw(chart, args, options){
    const {ctx, chartArea:{top, bottom, left, right}, width, height} = chart
    let fontWidth = width
    ctx.save()
    ctx.font = `bolder ${fontWidth*87/100}% Kanit`;
    // ctx.font = "bolder 2.8rem Kanit";
    ctx.fillStyle = "#224181";
    ctx.textAlign = "center";
    ctx.fillText(`${millionShortNum(props.totalData)}${millionShortString(props.totalData)}`, width/2, height/2)
    ctx.restore();
     ctx.font = `bolder ${fontWidth*40/100}% Kanit`;
    ctx.fillStyle = "#224181";
    ctx.textAlign = "center";
    ctx.fillText(`ครัวเรือน`, width/2, height/2 + (fontWidth*87/100)/10)


    // ctx.fillStyle = "#000";
    // // (xStart, yStart, width, height)
    // ctx.fillRect(width/2,top,1, bottom)
    // ctx.fillRect(left, height/2, right, 1)
  }
}
const chartDonutRef = ref()
const init = () => {
    const canvas = chartDonutRef.value?.getContext('2d')
    Chart.defaults.global.defaultFontFamily = "Kanit"
    const chart = new Chart(canvas, {
        type: 'doughnut',
        data: data.value,
        plugins:[stackedText],
        options: {
            layout:{
                padding: 20
            },
            tooltips: {
              callbacks: {
                title: function(tooltipItem, data) {
                  // console.log("title",data['labels'][tooltipItem[0]['index']]);
                  return data['labels'][tooltipItem[0]['index']];
                },
                label: function(tooltipItem, data) {
                  // console.log("label",data['datasets'][0]['data'][tooltipItem['index']]);
                  return new Intl.NumberFormat().format(data['datasets'][0]['data'][tooltipItem['index']]);
                },
              }
            },
            cutoutPercentage: 70,
            legend: {
              display: false,
              position: "bottom",
              align: "start",
              labels: {
                pointStyle: "circle",
                usePointStyle: true,
                boxWidth: 7,
                fontSize: 11,
                padding: 10,
                generateLabels(chart) {
                  var data = chart.data;
                  if (data.labels.length && data.datasets.length) {
                    return data.labels.map(function(label, i) {
                      var meta = chart.getDatasetMeta(0);
                      var ds = data.datasets[0];
                      var arc = meta.data[i];
                      var custom = (arc && arc.custom) || {};
                      var getValueAtIndexOrDefault =
                        Chart.helpers.getValueAtIndexOrDefault;
                      var arcOpts = chart.options.elements.arc;
                      var fill = custom.backgroundColor
                        ? custom.backgroundColor
                        : getValueAtIndexOrDefault(
                            ds.backgroundColor,
                            i,
                            arcOpts.backgroundColor
                          );
                      var stroke = custom.borderColor
                        ? custom.borderColor
                        : getValueAtIndexOrDefault(
                            ds.borderColor,
                            i,
                            arcOpts.borderColor
                          );
                      var bw = custom.borderWidth
                        ? custom.borderWidth
                        : getValueAtIndexOrDefault(
                            ds.borderWidth,
                            i,
                            arcOpts.borderWidth
                          );

                      // We get the value of the current label
                      var value =
                        chart.config.data.datasets[arc._datasetIndex].data[
                          arc._index
                        ];

                      return {
                        // Instead of `text: label,`
                        // We add the value to the string
                        text: `${label}: ${new Intl.NumberFormat().format(value)}`,
                        fillStyle: fill,
                        strokeStyle: stroke,
                        lineWidth: bw,
                        hidden: isNaN(ds.data[i]) || meta.data[i].hidden,
                        index: i,
                      };
                    });
                  } else {
                    return [];
                  }
                },
              },
            },
            responsive:true,
        },
    })
    //update chart data when dataset value change
    watch(data, () => {
      chart.data = data.value
      document.getElementById("firstLabels").innerText = chart.data.labels[0]
      document.getElementById("secondLabels").innerText = chart.data.labels[1]
      document.getElementById("thirdLabels").innerText = chart.data.labels[2]
      document.getElementById("firstLabelsBG").style.backgroundColor = chart.data.datasets[0].backgroundColor[0]
      document.getElementById("secondLabelsBG").style.backgroundColor = chart.data.datasets[0].backgroundColor[1]
      document.getElementById("thirdLabelsBG").style.backgroundColor = chart.data.datasets[0].backgroundColor[2]
      document.getElementById("firstLabelsAmount").innerText = `${millionShortNum(chart.data.datasets[0].data[0])} ${millionShortString(chart.data.datasets[0].data[0])}`
      document.getElementById("secondLabelsAmount").innerText = `${millionShortNum(chart.data.datasets[0].data[1])} ${millionShortString(chart.data.datasets[0].data[1])}`
      document.getElementById("thirdLabelsAmount").innerText = `${millionShortNum(chart.data.datasets[0].data[2])} ${millionShortString(chart.data.datasets[0].data[2])}`
      chartDonutRef.value.instance = chart
      chart.update()
    })
    
}
const toggleData = (val) =>{
  console.log("click ",chartDonutRef.value.instance);
  // console.log("ss",chartDonutRef.value.instance.data.datasets[0]._meta[1].data[0].hidden);
}
const getPercent = (idx)=>{
  return globalNumDecFixed(props.seriesData[idx] / (props.totalData / 100), 2)
}
onMounted(()=>{
    init()
})
</script>
<style lang="scss" scoped>
.custom-legend{
  display: inline-flex;
  align-items: baseline;
  gap: 8px;
  cursor: default;
  .labels-color{
    width: 8px;
    height: 8px;
    border-radius: 50%;
  }
}
</style>
